<template>
  <div class="box-main">
    <div class="main">
      <div>
        <div class="main-title">强制配置</div>
        <div class="main-title-tips no-border">可设定强制升级策略，强制升级策略需要设备端适配后才可生效</div>
        <div class="main-title-tips">注：基于SN的升级策略的优先级高于基于产品名称</div>
      </div>
      <div class="main-center">
        <v-button class="v-icon-add mr10" v-permission="'upgrade:policy:add'" type="primary" name="" @click="showEdit()">添加</v-button>
        <v-input class="mr10" v-model="search" placeholder="请输入搜索内容" suffix-icon="v-icon-search"></v-input>
        <v-button class="ml10 mr10" type="primary" name="" @click="handleSearch">查询</v-button>
        <v-button class="" type="info" name="" @click="handleClear">重置</v-button>
      </div>
      <div>
        <vxe-table border row-id="id" :data="table" @cell-click="cellClickEvent" align="left" :row-style="setRowClass">
          <vxe-table-column field="strategy_id" show-overflow min-width="120" title="ID"></vxe-table-column>
          <vxe-table-column field="strategy_typeshow" show-overflow min-width="160" title="策略类型"></vxe-table-column>
          <vxe-table-column field="product_name" show-overflow min-width="160" title="产品名称"></vxe-table-column>
          <vxe-table-column field="source_ver" show-overflow min-width="160" title="源版本"></vxe-table-column>
          <vxe-table-column field="target_ver" show-overflow min-width="160" title="目标版本"></vxe-table-column>
          <vxe-column field="upgrade_type" show-overflow min-width="160" title="升级时间">
            <template v-slot="slotProps">
              {{ slotProps.row.upgrade_type === 1 ? "立即升级" : `${slotProps.row.start_time}-${slotProps.row.end_time}` }}
            </template>
          </vxe-column>
          <vxe-table-column field="created_at" show-overflow min-width="160" title="上传时间"></vxe-table-column>
          <!-- <vxe-table-column field="updated_at" show-overflow min-width="160" title="更新时间"></vxe-table-column> -->
          <!-- <vxe-table-column field="memo" show-overflow min-width="160" title="备注"></vxe-table-column> -->
          <vxe-column title="操作" min-width="180">
            <template v-slot="slotProps">
              <span class="handle-button"
                ><v-button size="S" type="text" name="btn4" slot="reference" @click="showDetails(slotProps.row)">查看</v-button></span
              >
              <!-- <span class="handle-button"
                ><v-button size="S" type="text" name="btn1" slot="reference" @click="showEdit(slotProps.row)">管理</v-button></span
              > -->
              <span class="handle-button"
                ><v-button size="S" type="text" name="btn3" slot="reference" @click="showDel(slotProps.row)">删除</v-button></span
              >
            </template>
          </vxe-column>
        </vxe-table>
      </div>
      <v-pagination
        v-if="total"
        @change-page="changePage"
        @change-size="changeSize"
        :total="total"
        name="page-basic"
        is-show-total
        is-change-size
        is-input-page
        :current-page="currentPage"
      ></v-pagination>
    </div>
    <Edit :showInputDialog.sync="showEditDialog" ref="Edit" :row="row" @getData="getData()"></Edit>
    <Del :showInputDialog.sync="delLoading" ref="Del" :row="row" @getData="getData()"></Del>
    <Details :showInputDialog.sync="detailsLoading" ref="Details" :row="row" @getData="getData()"></Details>
  </div>
</template>
<script>
import Edit from "@/components/force-upgrade/edit.vue";
import Del from "@/components/force-upgrade/del.vue";
import Details from "@/components/force-upgrade/details.vue";

const STRATEGY_TYPE = {
  basesn: "基于设备SN",
  baseproduct: "基于产品名称",
};
export default {
  components: { Del, Details, Edit },
  data() {
    return {
      delLoading: false,
      detailsLoading: false,
      showEditDialog: false,
      search: "",
      row: {},
      currentPage: 1,
      pageSize: 10,
      table: [],
      total: 0,
    };
  },
  created() {
    this.getData();
  },
  watch: {},
  computed: {},
  methods: {
    cellClickEvent({ row, column }) {
      if (column.title == "操作") return;
      this.showDetails(row);
    },
    setRowClass({ rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return "background: #fafafa";
      }
    },
    async getData() {
      let searchData = this.search;
      if (this.search === "基于设备SN") {
        searchData = "basesn";
      } else if (this.search === "基于产品名称") {
        searchData = "baseproduct";
      }
      const subData = {
        page_num: this.currentPage,
        page_size: this.pageSize,
        search: searchData,
        app_id: sessionStorage.getItem("appid") || "",
      };
      const res = await this.$getData("/td/td-iot-api/iot/upgrade/force/page", subData);
      if (res.code === 0) {
        this.table = res.data.list || [];
        this.table.forEach((x) => {
          x.strategy_typeshow = STRATEGY_TYPE[x.strategy_type];
        });
        this.total = res.data.page_result.total;
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.getData();
    },
    handleClear() {
      this.search = "";
      this.changePage(1);
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    changeSize(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.getData();
    },
    showEdit(row) {
      this.showEditDialog = true;
      this.row = row || {};
    },
    showDel(row) {
      this.delLoading = true;
      this.row = row;
    },
    showDetails(row) {
      this.detailsLoading = true;
      this.row = row;
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">
.tabs-btns.v-tabs {
  .tab-nav--card {
    margin-bottom: 0;
  }
  .tab-pane-wrapper {
    height: 0;
  }
}
</style>
